import { render, staticRenderFns } from "./TerminologyFilterFacet.vue?vue&type=template&id=696a0b83&scoped=true"
import script from "./TerminologyFilterFacet.vue?vue&type=script&lang=js"
export * from "./TerminologyFilterFacet.vue?vue&type=script&lang=js"
import style0 from "./TerminologyFilterFacet.vue?vue&type=style&index=0&id=696a0b83&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "696a0b83",
  null
  
)

export default component.exports